// extracted by mini-css-extract-plugin
export var active = "_k1-2";
export var recordingDot = "_k1-1";
export var recordingIndicator = "_k1-0";